// ============================================
// AUTHENTICATED LAYOUT ROUTE
// ============================================

import { createFileRoute, redirect } from '@tanstack/react-router';
import { CompanyLayout } from '@/layouts';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context }) => {
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: CompanyLayout,
});
